import { useState } from "react";
import PropTypes from "prop-types";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import DisableConnectServiceDropdown from "../DisableConnectServiceDropdown";

const DisableAutomatedSendModal = ({ show, onClose, listingUuid, setConnectedService }) => {
  const [reason, setReason] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const hasError = submitted && !reason;

  const handleDisable = async () => {
    setSubmitted(true);
    if (!reason) return;
    setIsLoading(true);
    const response = await caseTransformingAxios.patch("/api/v4/transactions/connected_services", {
      uuid: listingUuid,
      disabled_reason: reason.value,
      authenticity_token: window.ReactOnRails.authenticityToken(),
    });
    setConnectedService(response.data);
    setIsLoading(false);
    onClose();
  };

  const handleClose = () => {
    setReason(null);
    setSubmitted(false);
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-min-h-full tw-max-h-full"
      contentClassName="tw-w-[440px] tw-m-auto"
    >
      <Modal.Header closeButton title="Disable Automated Send" />

      <Modal.Body className="tw-flex tw-flex-col tw-gap-32px tw-mt-12px">
        <div className="tw-text-14d tw-text-neutral-gray-50">
          If you <strong>do not want to send</strong> the buyer or tenant&apos;s contact information to
          Connect Services, you can disable the automation for this transaction. Please record a reason for
          disabling it.
        </div>

        <DisableConnectServiceDropdown
          value={reason}
          onChange={setReason}
          error={hasError ? "Please record a reason to share with your team." : null}
        />
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-mt-32px">
        <Button size="medium" schema="tertiary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          size="medium"
          schema="warning"
          disabled={!reason}
          isLoading={isLoading}
          onClick={handleDisable}
        >
          Disable
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DisableAutomatedSendModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  listingUuid: PropTypes.string,
  setConnectedService: PropTypes.func,
};

DisableAutomatedSendModal.defaultProps = {
  show: false,
  onClose: () => {},
  listingUuid: "",
  setConnectedService: () => {},
};

export default DisableAutomatedSendModal;
